
import { Component, Prop, Vue } from 'vue-property-decorator';
import Field from '~/components/Field.vue';
import { FieldObject } from '~/interfaces/field.interface';

@Component({
    components: {
        Field,
    },
})
export default class FieldsCard extends Vue {
    @Prop() readonly title!: string;
    @Prop() readonly fields!: FieldObject[];
}
